import React, { useState } from 'react';
import { DefaultButton, MessageBar, MessageBarType } from '@fluentui/react';

export default function SyncButton({ clientPrincipal, onSyncComplete }) {
    const [status, setStatus] = useState(null);

    const handleSyncTrigger = async () => {
        try {
            setStatus({ type: 'info', message: 'Syncing...' });
            
            const response = await fetch('/api/sync-trigger', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-ms-client-principal-id': clientPrincipal.userId
                }
            });
            
            const data = await response.json();
            
            if (response.status === 401) {
                setStatus({ 
                    type: 'warning', 
                    message: (
                        <div>
                            <div>Authentication needed for: {data.expiredTenants.join(', ')}</div>
                            <DefaultButton
                                text="Go to Settings"
                                onClick={() => window.location.href = '/settings'}
                            />
                        </div>
                    )
                });
            } else if (response.status === 200) {
                setStatus({ type: 'success', message: 'Sync completed successfully' });
                onSyncComplete?.();
            } else {
                setStatus({ type: 'error', message: data.message || 'Sync failed' });
            }
        } catch (error) {
            setStatus({ type: 'error', message: `Sync failed: ${error.message}` });
        }
    };
    
    return (
        <div>
            <DefaultButton 
                text="Sync Now"
                onClick={handleSyncTrigger}
            />
            {status && (
                <MessageBar messageBarType={MessageBarType[status.type]}>
                    {status.message}
                </MessageBar>
            )}
        </div>
    );
}
